import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { ComponentCanDeactivate } from "./component-can-deactivate";

@Injectable({
  providedIn: "root",
})
export class PendingChangesGuardService
   {
  canDeactivate(
    component: ComponentCanDeactivate
  ): boolean | Observable<boolean> {
    if (component.canDeactivate()) {
      return true;
    } else {
      return confirm(
        "You have unsaved changes. Press Cancel to go back and submit these changes, or OK to lose these changes."
      );
    }
  }
}
